import BookingForm from './src/modules/booking-form';
const loader = require('scriptjs');

import DatePickers from './src/modules/datepickers';
import Forms from './src/modules/forms';
import Lightbox from './src/modules/lightbox';
import Navigation from './src/modules/navigation';
import Scroll from './src/modules/scroll';
// import Sliders from './src/modules/sliders.js';
import GoogleMap from './src/modules/map.js'

window.onload = function() {
	// Sliders.init();
	Scroll.init();
	Navigation.init();
	BookingForm.init();
	Forms.init();
	GoogleMap.init();
	// Object.create(DatePickers).init();

	if (document.querySelector('.luminous-gallery')) {
		Lightbox.init();
	}

	document.querySelector('.g-recaptcha') && loader('https://www.google.com/recaptcha/api.js', 'recaptcha');
}




